import { combineReducers } from "@reduxjs/toolkit";

import adminReducer from "./slices/admin";
import authReducer from "./slices/auth";
import toastReducer from "./slices/toast";

import productReducer from "./slices/product";
import clientReducer from "./slices/client";
import workerReducer from "./slices/worker";
import clientUserReducer from "./slices/clientUser";
import coordinatorParticipantReducer from "./slices/coordinatorParticipant";
import jobReducer from "./slices/job";
import rateReducer from "./slices/rate";
import scheduleReducer from "./slices/schedule";
import bookingReducer from "./slices/booking";
import supportReducer from "./slices/support";
import specialtyReducer from "./slices/specialty";
import accreditationReducer from "./slices/accreditation";
import languageReducer from "./slices/language";
import payrollReducer from "./slices/payroll";
import dashboardReducer from "./slices/dashboard";
import reimbursementReducer from "./slices/reimbursement";
import billingReducer from "./slices/billing";
import notificationReducer from "./slices/notification";
import layoutReducer from "./slices/layout";
import processNoteReducer from "./slices/processNote";
import chatReducer from "./slices/chat";
import companyReducer from './slices/company';
import companyUserReducer from './slices/companyUser';
import subscriptionReducer from './slices/subscription';
import companyTransactionReducer from './slices/companyTransaction';
import importWorkerReducer from './slices/importWorker';
import importClientReducer from './slices/importClient';
import appraisalReducer from './slices/appraisal';
import medicationReducer from './slices/medication';
import goalTrackerReducer from './slices/goalTracker';
import incidentReducer from './slices/incident';
import actionReducer from './slices/action';
import complaintReducer from './slices/complaint';
import investigationReducer from './slices/investigation';
export default combineReducers({
  auth: authReducer,
  toasts: toastReducer,
  admin: adminReducer,
  client: clientReducer,
  worker: workerReducer,
  product: productReducer,
  clientUser: clientUserReducer,
  coordinatorParticipant: coordinatorParticipantReducer,
  job: jobReducer,
  rate: rateReducer,
  schedule: scheduleReducer,
  booking: bookingReducer,
  support: supportReducer,
  specialty: specialtyReducer,
  accreditation: accreditationReducer,
  language: languageReducer,
  payroll: payrollReducer,
  reimbursement: reimbursementReducer,
  billing: billingReducer,
  notification: notificationReducer,
  layout: layoutReducer,
  dashboard: dashboardReducer,
  processNote: processNoteReducer,
  chat: chatReducer,
  company: companyReducer,
  companyUser: companyUserReducer,
  subscription: subscriptionReducer,
  companyTransaction: companyTransactionReducer ,
  importStaff: importWorkerReducer,
  importClient: importClientReducer,
  appraisal: appraisalReducer,
  medication: medicationReducer,
  goalTracker: goalTrackerReducer,
  incident: incidentReducer,
  action: actionReducer,
  complaint: complaintReducer,
  investigation: investigationReducer,
});
